import { QUERY_KEY, SORT_KEY, LIMIT_KEY, OFFSET_KEY } from '@yme/common/constants';
import { Network } from '@yme/services/network';
export async function getProductsByCategoryId({ endpoint, parameters: { categoryIds, sortOrder = [], limit, offset = 0 }, }) {
    const limitQuery = limit ? `${LIMIT_KEY}=${limit}` : `${LIMIT_KEY}=`;
    const parameters = [
        `${QUERY_KEY}=${[...categoryIds].join('|')}`,
        `${SORT_KEY}=${sortOrder.join('|')}`,
        limitQuery,
        `${OFFSET_KEY}=${offset}`,
    ].join('&');
    const uri = `${endpoint}&${parameters}`;
    const encodedUri = encodeURI(uri);
    const response = await Network.get(encodedUri);
    const result = response.data;
    return result;
}
